import { each } from 'lodash';
import { LOAD_DYNAMIC_DATA, CLEAR_DYNAMIC_DATA } from './actions';

const initialState = {
  objects: {},
};

const DynamicCellReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DYNAMIC_DATA: {
      const { results, resourceType } = action;
      const { objects } = state;
      const newResources = objects[resourceType] ? { ...objects[resourceType] } : {};
      each(results, (result) => {
        newResources[result.id] = { ...result };
      });
      const newObjects = {
        ...objects,
        [resourceType]: newResources,
      };
      return { ...state, objects: newObjects };
    }
    case CLEAR_DYNAMIC_DATA: {
      const { resourceType } = action;
      const { objects } = state;
      const newObjects = {
        ...objects,
        [resourceType]: {},
      };
      return { ...state, objects: newObjects };
    }
    default:
      return state;
  }
};

export const getObject = (state, type, id) => {
  const resources = state.dynamicCell.objects[type] || {};
  const resource = resources[id];
  return resource;
};
export const getObjectStatus = (state, type, id) => {
  const resource = getObject(state, type, id);
  return resource ? resource.status : null;
};
export const getObjectData = (state, type, id) => {
  const resource = getObject(state, type, id);
  return resource ? resource.data : null;
};

// Export Reducer
export default DynamicCellReducer;
